var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTermsOfUse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 64,
    viewBox: "0 0 56 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5538 11.1797C51.2605 11.1797 48.1888 10.0456 47.2188 9.55949C41.8838 7.12912 32.9922 0 27.9805 0C22.9689 0 14.2389 7.12912 8.74224 9.55949C7.77224 10.0456 4.70057 11.0177 3.40724 11.1797C1.30558 11.3418 -0.149417 13.1241 0.0122491 15.0684C0.497248 19.7671 1.79057 28.3544 5.18557 39.2101C9.3889 52.8203 21.5139 60.9215 26.0405 63.5139C27.1722 64.162 28.4655 64.162 29.5972 63.5139C34.1239 60.9215 46.2488 52.6582 50.4522 39.2101C53.8472 28.3544 55.1405 19.7671 55.6255 15.0684C56.1105 13.1241 54.6555 11.3418 52.5538 11.1797Z",
    fill: "url(#paint0_linear_628_4239)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.937 15.8786C50.452 19.6051 49.482 25.6001 47.3803 33.2153C47.2187 33.7013 47.057 34.0254 47.057 34.5115C46.7337 35.6456 46.4103 36.6178 46.087 37.752C43.9853 44.395 39.782 49.5798 35.7403 53.1444C32.8303 55.7368 30.082 57.6811 28.142 58.8153C27.657 58.4912 27.172 58.1672 26.5254 57.8431C21.5137 54.4406 13.2687 47.7975 10.197 37.59C7.12538 27.8684 5.83205 20.0912 5.34705 15.7165C7.77204 15.2305 10.5204 14.0963 11.0054 13.9343C13.107 12.9621 15.532 11.5039 18.1187 9.88363C21.0287 8.10135 26.202 4.86084 28.142 4.86084C30.082 4.86084 35.2553 8.10135 38.1653 9.88363C40.752 11.5039 43.177 12.9621 45.2787 13.9343C45.7637 14.2583 48.512 15.3925 50.937 15.8786Z",
    fill: "url(#paint1_linear_628_4239)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.3802 33.2153C47.2186 33.7014 47.0569 34.0254 47.0569 34.5115C46.7336 35.6457 46.4102 36.6178 46.0869 37.752C43.9852 44.3951 39.7819 49.5799 35.7402 53.1444L21.3519 38.7242L22.3219 31.271L30.7286 27.0583L25.5553 27.5444L24.1003 18.7951L31.5369 17.1748L47.3802 33.2153Z",
    fill: "url(#paint2_linear_628_4239)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8303 25.2762V20.7395C32.8303 18.6332 31.0519 16.2028 28.9503 15.8787C27.3336 15.5547 25.7169 16.2028 24.7469 17.1749C23.9386 17.9851 23.2919 19.2813 23.2919 20.5775V25.2762C21.9986 26.0863 20.8669 27.2205 20.2203 28.5167C19.5736 29.8129 19.0886 31.1091 19.0886 32.7294C18.9269 37.5901 22.9686 41.9648 27.8186 42.1268C32.9919 42.2889 37.1953 38.2382 37.1953 33.0534C37.1953 29.6509 35.4169 26.8964 32.8303 25.2762ZM29.2736 34.0256V36.4559C29.2736 36.78 28.9503 37.104 28.6269 37.104H27.6569C27.3336 37.104 27.0103 36.78 27.0103 36.4559V34.9977V34.0256C26.2019 33.5395 25.7169 32.7294 25.8786 31.5952C26.0403 30.7851 26.6869 29.9749 27.6569 29.8129C29.1119 29.4889 30.4053 30.623 30.4053 32.0813C30.4053 32.8914 29.9203 33.7015 29.2736 34.0256ZM30.8903 24.304C30.0819 23.98 29.1119 23.818 28.1419 23.818C27.3336 23.818 26.3636 23.98 25.5553 24.142V20.5775C25.5553 19.9294 25.8786 19.1192 26.3636 18.6332C27.0103 17.9851 28.1419 17.661 29.2736 17.9851C30.2436 18.3091 30.8903 19.4433 30.8903 20.5775V24.304Z",
    fill: "url(#paint3_linear_628_4239)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_628_4239",
    x1: 24.92,
    y1: 19.8434,
    x2: 43.0913,
    y2: 45.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#264BCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_628_4239",
    x1: 44.6292,
    y1: 46.5436,
    x2: 17.2629,
    y2: 11.7715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#264BCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_628_4239",
    x1: 32.2717,
    y1: 33.9564,
    x2: 42.3095,
    y2: 43.9721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C94FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_628_4239",
    x1: 37.0761,
    y1: 38.7517,
    x2: 20.1612,
    y2: 21.8742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#C2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsOfUse);
export default __webpack_public_path__ + "static/media/terms-of-use.57a72807f8f242d46999a20c995565d4.svg";
export { ForwardRef as ReactComponent };